"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./scss/loading-rects.scss");

var styles = {
  height: '100vh',
  width: '100%',
  position: 'relative'
};

var Loading = function Loading() {
  return _react["default"].createElement("div", {
    style: styles
  }, _react["default"].createElement("div", {
    className: "spinner"
  }, _react["default"].createElement("div", {
    className: "rect1"
  }), _react["default"].createElement("div", {
    className: "rect2"
  }), _react["default"].createElement("div", {
    className: "rect3"
  }), _react["default"].createElement("div", {
    className: "rect4"
  }), _react["default"].createElement("div", {
    className: "rect5"
  })));
};

var _default = Loading;
exports["default"] = _default;